import axios from "axios";

const httpCore = axios.create({
  baseURL: "http://127.0.0.1:8000/api",
  headers: { "Content-Type": "application/json" },
});

export const listHospitals = () => httpCore.get("/hospitals/?format=json");

export const listDepartmentsByHospital = (hospitalId) =>
  httpCore.get(`/departments/?hospital=${hospitalId}&format=json`);

export const listWardsByHospital = (hospitalId) =>
  httpCore.get(`/wards/?hospital=${hospitalId}&format=json`);

// // ✅ Room list depends on Ward
// export const listRoomsByWard = (wardId) =>
//   httpCore.get(`/rooms/?ward=${wardId}&format=json`);